import Box from "@mui/material/Box";

export const getHarmText = (val) => {
  let text = "";
  if (val < 0.25) {
    text = "Low";
  } else if (val < 0.5) {
    text = "Med";
  } else if (val < 0.8) {
    text = "High";
  } else {
    text = "Very High";
  }
  return text;
};

export default function HarmDot({ dotStyles, size = "100%", printStyles, value, isPrintModeEnabled = false }) {
  return (
    <Box
      sx={{
        width: !isPrintModeEnabled ? size : "auto",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isPrintModeEnabled && (
        <Box 
        sx={{ 
          borderRadius: "4px",
          paddingLeft: "10px",
          paddingRight: "10px",
          ...(printStyles || {})
        }}>{value.toUpperCase()}</Box>
      )}
      {!isPrintModeEnabled && (
        <Box
          sx={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            ...(dotStyles || {})
          }}
        ></Box>
      )}
    </Box>
  );
}
